import { HighLightClass } from '@helpers/HighLight.class';

const highLights = document.querySelectorAll<HTMLElement>('.kf-o-highlights');

highLights.forEach((highLight) => {
  const highLightInstance = new HighLightClass({
    element: highLight,
  });

  highLightInstance.init();
});

export {};
